export default __webpack_public_path__ + "static/balsamic-efa5b057c82569a19e317ea9f6d1c351.png";